import React, { createContext, useState, useContext } from 'react';
import inventoriesApi from '../services/inventoriesApi';
import { AppContext } from './AppContext';

export const InventoriesContext = createContext();

const InventoriesContextProvider = props => {
  const [countries, setCountries] = useState([]);
  const [regions, setRegions] = useState([]);
  const [areas, setAreas] = useState([]);
  const [roles, setRoles] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [criticalSuppliers, setCriticalSuppliers] = useState([]);
  const [treasuryGroups, setTreasuryGroups] = useState([]);
  const [claimTypes, setClaimTypes] = useState([]);
  const { getCountries, getAreas, getRegions, getRoles, getSuppliers, getTreasuryGroups, getClaimTypes, getCriticalSuppliers } = inventoriesApi;


  const { showError } = useContext(AppContext);

  const getInfo = async (array, getData, setData, infoAbout) => {
    return array.isEmpty()
      ? getData()
          .then(result => {
            setData(result);
            return result;
          })
          .catch(error => {
            showError(`Error al obtener los datos de ${infoAbout}`);
            throw error;
          })
      : Promise.resolve(array);
  };

  const getTheRegions = () => getInfo(regions, getRegions, setRegions, 'regiones');
  const getTheCountries = () => getInfo(countries, getCountries, setCountries, 'paises');
  const getTheAreas = () => getInfo(areas, getAreas, setAreas, 'areas');
  const getTheRoles = () => getInfo(roles, getRoles, setRoles, 'roles');
  const getTheSuppliers = () => getInfo(suppliers, getSuppliers, setSuppliers, 'proveedores');
  const getTheCriticalSuppliers = () => getInfo(criticalSuppliers, getCriticalSuppliers, setCriticalSuppliers, 'proveedores criticos');
  const getTheTreasuryGroups = () => getInfo(treasuryGroups, getTreasuryGroups, setTreasuryGroups, 'proveedores');
  const getTheClaimTypes = () => getInfo(claimTypes, getClaimTypes, setClaimTypes, 'tipos de reclamo');

  return (
    <InventoriesContext.Provider
      value={{ getTheRegions, getTheCountries, getTheAreas, getTheRoles, getTheSuppliers, getTheTreasuryGroups, getTheClaimTypes, getTheCriticalSuppliers }}>
      {props.children}
    </InventoriesContext.Provider>
  );
};

export default InventoriesContextProvider;
